<template>
    <div>
        <Breadcrumb section-name="Report" :breadcrumb="breadCrumb"></Breadcrumb>
        <div class="col-12">
            <div class="card mb-0">
                <div class="card-body">
                    <div class="row mb-3 g-2 align-items-end">
                        <div class="col-auto">
                            <a class="btn btn-option" href="javascript:void(0)" @click="downloadFile">
                                <img v-if="!exportLoading" class="print" width="16" height="16"/>
                                <span v-if="exportLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </a>
                        </div>
                        <div class="col-md-3 form-group mb-0">
                            <select class="form-control" v-model="params.project_id" name="project_id">
                                <option value="">Select Project</option>
                                <option v-for="each in projects" :value="each.id" v-text="each.name"></option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-inverse-primary w-100" @click="fetchDepositAmount">Search</button>
                        </div>
                    </div>
                    <div class="table-height long-scroll">
                        <table class="table mb-0 table-striped table-bordered dataTable">
                            <thead>
                            <tr>
                                <th>নং</th>
                                <th>আইডি</th>
                                <th>শেয়ার হোল্ডার এর নাম</th>
                                <th>মোট শেয়ার</th>
                                <th class="text-end">এখন পর্যন্ত টাকা জমা দেবার কথা</th>
                                <th class="text-end">এখন পর্যন্ত টাকা জমা দিয়েছে</th>
                                <th class="text-end">বাকী টাকা পাওয়া যাবে</th>
                                <th class="text-end">অতিরিক্ত টাকা জমা দেওয়া আছে</th>
                                <th>Image</th>
                            </tr>
                            </thead>
                            <template v-if="!loading && reportData['data']?.length > 0">
                                <tbody>
                                <tr v-for="(data,index) in reportData['data']">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ data.id_number }}</td>
                                    <td>{{ data.name }}</td>
                                    <td>{{ data.total_share }}</td>
                                    <td class="text-end">{{ data.deposit_amount_will_be }}</td>
                                    <td class="text-end">{{ data.total_deposit }}</td>
                                    <td class="text-end">{{ data.remaining_amount }}</td>
                                    <td class="text-end">{{ data.extra_deposit_amount }}</td>
                                    <td>
                                        <img style="width: 60px; height: 60px" :src="data.image_path" alt="">
                                    </td>
                                </tr>
                                </tbody>
                                <tfoot>
                                <tr>
                                    <th class="text-end" colspan="3">Total</th>
                                    <th>{{ reportData.total.total_share  }}</th>
                                    <th class="text-end">{{ reportData.total.deposit_amount_will_be  }}</th>
                                    <th class="text-end">{{ reportData.total.total_deposit  }}</th>
                                    <th class="text-end">{{ reportData.total.remaining_amount  }}</th>
                                    <th class="text-end">{{ reportData.total.extra_deposit_amount  }}</th>
                                    <th></th>
                                </tr>
                                </tfoot>
                            </template>
                            <template v-if="!loading && reportData['data']?.length === 0">
                                <tr class="text-center">
                                    <td colspan="100" class="fw-bold fs-6 text-height">
                                        No Data Found
                                        <br>
                                        Please search by project.
                                    </td>
                                </tr>
                            </template>

                            <tbody v-if="loading">
                            <tr>
                                <td colspan="100" class="loader-height">
                                    <Loader></Loader>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ApiService from "../../Services/ApiService";
import PrintService from "../../Services/PrintService";
import ApiRoutes from "../../Services/ApiRoutes";
import ConfirmDialogue from "../Common/confirmPopup/ConfirmDialogue.vue";
import Table from "../Common/Table.vue";
import Breadcrumb from "../Common/Breadcrumb.vue";
import Unit from "../Settings/Unit/Unit.vue";
import Loader from "../Common/Loader.vue";

export default {
    components: {Loader, Unit, Breadcrumb, Table, ConfirmDialogue},
    data() {
        return {
            breadCrumb: ['Deposit Amount'],
            reportData: [],
            projects: [],
            params: {
                project_id: ''
            },
            loading: false,
            exportLoading: false,

        }
    },
    methods: {
        downloadFile: function () {
            PrintService.print('/report/deposit-amount/' + this.params.project_id);
        },
        fetchProject() {
            ApiService.POST(ApiRoutes.Project + '/list', {limit: 500}, (res) => {
                if (parseInt(res.status) === 200) {
                    this.projects = res.data.data;
                }
            });
        },
        fetchDepositAmount() {
            this.loading = true;
            ApiService.POST(ApiRoutes.Report + '/deposit-amount', this.params, (res) => {
                this.loading = false;
                if (parseInt(res.status) === 200) {
                    this.reportData = res;
                }
            });
        }
    },
    created() {
        this.fetchProject();
    }
}
</script>

<style scoped>

</style>
